<template>
  <unicom-linha class="linha-embaixo">
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Remoção externa/independente</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna>

    <unicom-coluna sm="5" :class="espacamentoMobile">
      <Multiselect
        v-model="payload.tipoServicoEspecialidade"
        :propsMultiselect="{
          placeholder: 'Qual o tipo de Ambulância',
          options: listaTiposRemocao,
          'track-by': 'id',
          label: 'tipoServicoEspecialidade'
        }"
        v-show="clickSwitch"
      />
    </unicom-coluna>

    <unicom-coluna sm="4" :class="espacamentoMobile">
      <single-select
        @input="atualizarAbrangencias"
        :propsSingleSelect="{
          placeholder: 'Abrangência do serviço',
          options: listaAbrangencias,
          'track-by': 'id',
          label: 'tipoServicoAbrangencia'
        }"
        :value="payload.tipoServicoAbrangencia[0]"
        v-show="clickSwitch"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import Multiselect from "@/views/RecursosPropriosQuestionarios/shared/Multiselect.vue";
import SingleSelect from "@/views/RecursosPropriosQuestionarios/shared/Singleselect.vue";

import SharedMixin from "./SharedMixin.js";

export default {
  mixins: [SharedMixin],
  components: {
    Multiselect,
    SingleSelect
  },
  data() {
    return {
      payload: {
        tipoServico: "Remoção externa/independente",
        tipoServicoEspecialidade: [],
        tipoServicoAbrangencia: []
      },
      listaTiposRemocao: [],
      listaAbrangencias: []
    };
  },
  beforeMount() {
    this.inicializarEspecialidades();
    this.inicializarAbrangencias();
  },
  methods: {
    inicializarEspecialidades() {
      return this.getEspecialidades(this.servico.id).then(({ data }) => {
        if (data) {
          this.listaTiposRemocao = [...data];
        }
      });
    },
    atualizarAbrangencias(valor) {
      this.payload.tipoServicoAbrangencia = [];
      if (!valor || valor.length < 1) return;
      this.payload.tipoServicoAbrangencia.push(valor);
    },
    inicializarAbrangencias() {
      return this.getAbrangencia(this.servico.id).then(({ data }) => {
        if (data) {
          this.listaAbrangencias = [...data];
        }
      });
    }
  },
  watch: {
    "payload.tipoServicoAbrangencia": "emitir",
    "payload.especialidadesOferecidas": "emitir",
    dadosServidor(newVal) {
      if (newVal.especialidades.length > 0) {
        newVal.especialidades.forEach(especialidade => {
          if (
            especialidade.tipoServico.tipoServico === this.payload.tipoServico
          ) {
            this.clickSwitch = true;
            this.preencheCampo(
              "especialidade",
              especialidade.tipoServicoEspecialidade
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
      if (newVal.servicos.length > 0) {
        newVal.servicos.forEach(servico => {
          if (
            servico.tipoServico.tipoServico === this.payload.tipoServico &&
            (servico.especialidadesOferecidas || servico.outro)
          ) {
            this.clickSwitch = true;
            this.preencheCampo(
              "especialidades oferecidas",
              servico.especialidadesOferecidas
            );
            this.preencheCampo("outro", servico.outro);
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
      if (newVal.abrangencias.length > 0) {
        newVal.abrangencias.forEach(abrangencia => {
          if (
            abrangencia.tipoServico.tipoServico === this.payload.tipoServico
          ) {
            this.clickSwitch = true;
            this.preencheCampo(
              "abrangencia",
              abrangencia.tipoServicoAbrangencia
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.unicom-linha {
  margin-bottom: 24px;
}
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
#titulo {
  font-size: 15px;
  padding-top: 8px;
  text-align: center;
}

.procedimentos {
  margin: 1rem 0;
}
</style>
